import React from 'react'
import { useState } from 'react';
import { Box, useMediaQuery } from '@mui/material';
import { useSelector } from 'react-redux';
import Navbar from 'components/Navbar'
import { Outlet } from 'react-router-dom';
import Sidebar from "components/Sidebar"
import { useGetUserQuery } from 'state/api';

const DRAWER_WIDTH = 250;

const Layout = () => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const userId = useSelector((state) => state.global.userId);
  const { data } = useGetUserQuery(userId);
  console.log('data', data);

  return (
    <Box display={isNonMobile ? "flex" : "block"} width="100%" height="100%">
      <Sidebar
        user={data || {}}
        isNonMobile={isNonMobile}
        drawerWidth={`${DRAWER_WIDTH}px`}
        isSidebarOpen={isSidebarOpen}
        setIsSidebarOpen={setIsSidebarOpen}
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          // Drawer persistent : quand il se ferme il garde sa place dans le DOM.
          // On compense avec un margin-left négatif égal à sa largeur.
          marginLeft: isNonMobile
            ? isSidebarOpen
              ? 0                        // sidebar ouvert → flex gère l'espace
              : `-${DRAWER_WIDTH}px`     // sidebar fermé → on récupère les 250px
            : 0,                         // mobile → pas de décalage
          transition: 'margin-left 0.3s ease',
          width: isNonMobile
            ? isSidebarOpen
              ? `calc(100% - ${DRAWER_WIDTH}px)`
              : '100%'
            : '100%',
          overflow: 'hidden',
        }}
      >
        <Navbar
          user={data || {}}
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
        />
        <Outlet />
      </Box>
    </Box>
  );
};

export default Layout;
